/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

function placeholderField($) {
  var PlaceholderField = ($.fn.PlaceholderField = function() {
    if (PlaceholderField.hasNativePlaceholderSupport()) {
      return this;
    }

    return this.each(function() {
      return PlaceholderField.initPlaceholder($(this));
    });
  });

  PlaceholderField.hasNativePlaceholderSupport = () =>
    _.all(
      [document.createElement('input'), document.createElement('textarea')],
      elem => elem.placeholder != null
    );

  const inputEmpty = $input => /^\s*$/.test($input.val());

  PlaceholderField.initPlaceholder = function($input) {
    let focusout;

    function focusin() {
      if (defaultPromptEnabled($input)) {
        return $input.val('').removeClass('prompting');
      }
    }

    (focusout = function focusout() {
      if (inputEmpty($input)) {
        return setPlaceholder($input);
      }
    })();

    return $input.on({ focusin, focusout });
  };

  function setPlaceholder($input) {
    let left;
    $input.addClass('prompting');
    return $input.val(
      (left = $input.attr('placeholder')) != null ? left : $input.attr('title')
    );
  }

  function defaultPromptEnabled($input) {
    const sansWhitespace = val => val.replace(/\s/g, '');
    const placeholder =
      $input.attr('placeholder') || $input.attr('title') || '';
    return sansWhitespace($input.val()) === sansWhitespace(placeholder);
  }

  return PlaceholderField;
}

module.exports = placeholderField;
